import { User } from 'module/api/user/types';

export const fullName = (user: Pick<User, 'firstName' | 'lastName'>): string =>
  [user?.firstName ?? '', user?.lastName ?? ''].join(' ').trim();
